"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _FlyoutFullScreen_css = _interopRequireDefault(require("./FlyoutFullScreen_css"));
var _modalUtils = require("../utils/modalUtils");
var _TabbingTrapper = _interopRequireDefault(require("../TabbingTrapper"));
class FlyoutFullScreen extends _react.default.Component {
  constructor(props) {
    super(props);

    // get the element the flyout will be injected into
    this.modalRoot = (0, _modalUtils.getModalRoot)();

    // Create a div that we'll render the modal into. Because each
    // Modal component has its own element, we can render multiple
    // modal components into the modal container.
    this.element = document.createElement("div");
    this.applyWrapper = this.applyWrapper.bind(this);
    this.close = this.closeFlyout.bind(this);
    this.handleFlyoutClick = this.handleFlyoutClick.bind(this);

    // manual overrides for booking app
    (0, _appendCss.default)("arc_flyoutfullscreen", _FlyoutFullScreen_css.default);
  }
  componentDidMount() {
    this.modalRoot.appendChild(this.element);
  }
  componentWillUnmount() {
    this.modalRoot.removeChild(this.element);
  }
  applyWrapper() {
    const flyoutClasses = (0, _classnames.default)({
      "FlyoutFullScreenContainer--flyout": true,
      "no-padding": !this.props.defaultPadding
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "FlyoutFullScreenContainer ".concat(this.props.variant)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "FlyoutFullScreenContainer--overlay",
      onClick: this.close
    }), /*#__PURE__*/_react.default.createElement(_TabbingTrapper.default, {
      escCallback: this.close,
      focusElement: this.props.focusOnOpen
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: flyoutClasses,
      onClick: this.handleFlyoutClick,
      role: "dialog",
      "aria-modal": "true"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "FlyoutFullScreenContainer--content"
    }, this.props.children))));
  }
  handleFlyoutClick() {
    if (this.props.closeOnClick) {
      this.close();
    }
  }
  closeFlyout() {
    if (this.props.onClose !== null) {
      this.props.onClose();
      (0, _modalUtils.handleFocusElement)(this.props.focusOnClose);
    }
  }
  render() {
    // short circuit if should be closed
    if (!this.props.isOpen) return null;

    // Use a portal to render the children into the element
    return /*#__PURE__*/_reactDom.default.createPortal(
    // Any valid React child: JSX, strings, arrays, etc.
    this.applyWrapper(),
    // A DOM element
    this.element);
  }
}
exports.default = FlyoutFullScreen;
FlyoutFullScreen.propTypes = {
  /** The id for the element to anchor to.  If ommitted, flyout will center itself. */
  anchorId: _propTypes.default.string,
  /** Boolean to tell the flyout to close when the user clicks within the flyout. Default: false. */
  closeOnClick: _propTypes.default.bool,
  /** Boolean to apply (or not) some padding to flyout container. default: true */
  defaultPadding: _propTypes.default.bool,
  /** Conditionally show/hide flyout. */
  isOpen: _propTypes.default.bool,
  /** Function to call onClose of flyout */
  onClose: _propTypes.default.func,
  /** A css class name added to the this instance of the flyout */
  variant: _propTypes.default.string,
  /** CSS query selector value for the element that should recieve initial focus */
  focusOnOpen: _propTypes.default.string,
  /** react REF object for the focusable element that should be refocused when the modal closes */
  focusOnClose: _propTypes.default.object
};
FlyoutFullScreen.defaultProps = {
  anchorId: null,
  closeOnClick: false,
  defaultPadding: true,
  isOpen: false,
  onClose: null,
  variant: "",
  focusOnOpen: null,
  focusOnClose: null
};